import { render, staticRenderFns } from "./AddBuyPackage.vue?vue&type=template&id=648186b1&"
import script from "./AddBuyPackage.vue?vue&type=script&lang=js&"
export * from "./AddBuyPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports